import React, { useEffect, useState } from 'react';
import UserHeader from '../../UserHeader';
import { Card, CardContent, CardHeader, Button, TextField, MenuItem } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLocation, useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import { basicDetailEditSchema } from '../../../ValidationSchema';
import { editBasicDetailData, getBloodGroup, getHeight, getMaritualStatus, getProfileByList } from '../../../../asiosConfig';
import Popup from '../../../Popup';
import moment from 'moment/moment';

export const BasicDetailsEdit = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const basicData = location.state?.userProfileData || {};
  const [height, setHeight] = useState([]);
  const [bloodgroup, setBloodGroup] = useState([]);
  const [maritalstatus, setMaritalStatus] = useState([]);
  const [ages, setAges] = useState([]);
  const [profileByList, setProfileByList] = useState([]);

  // State to control visibility of "Have Children" and "Children Living Status"
  const [showChildrenField, setShowChildrenField] = useState(false);
  const [showChildrenLivingStatus, setShowChildrenLivingStatus] = useState(false);
  const [popupData, setPopupData] = useState({ open: false, type: '', message: '' });

  const handleClosePopup = () => {
    setPopupData({ ...popupData, open: false });
  };

  useEffect(() => {
    if (popupData.open) {
      const timer = setTimeout(() => {
        setPopupData(prev => ({ ...prev, open: false }));
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [popupData.open]);

  const calculateAge = (date_of_birth) => {
    const birthDate = new Date(date_of_birth);
    const today = new Date();
    const age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      return age--;
    }
    return age;
  }
  const date_of_birth = basicData.date_of_birth
    ? moment(basicData.date_of_birth).format('YYYY-MM-DD')
    : '';

  const formik = useFormik({
    initialValues: {
      name: basicData.name || '',
      last_name: basicData.last_name || '',
      date_of_birth: date_of_birth || '',
      age: basicData.age || '',
      gender: basicData.gender || '',
      maritalStatus: basicData.maritalStatus || '',
      height: basicData?.height_id || '',
      bloodGroup: basicData.bloodGroup || '',
      about_me: basicData.about_me || '',
      no_of_Children: basicData.no_of_Children || '',
      childrenLivingStatus: basicData.childrenLivingStatus || '',
      registerBy: basicData.registerby || '',
      user_id: localStorage.getItem("user_id"),
      // tokan: localStorage.getItem('token'),
    },
    validationSchema: basicDetailEditSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const response = await editBasicDetailData(values);
        if (response.status === 200 || response.status === 201) {
          setPopupData({ open: true, type: 'success', message: response.data.message });
          setTimeout(() => {
            navigate(-1);
          }, 3000);
        } else {
          setPopupData({ open: true, type: 'error', message: "Fail to update Basic Details" });
        }
      } catch (error) {
        setPopupData({ open: true, type: 'error', message: error.message || "An error occurred" });
      } finally {
        setSubmitting(false);
      }
    }
  });

  useEffect(() => {
    const fetchHeight = async () => {
      try {
        const response = await getHeight();
        if (response.status === 200 || response.status === 201) {
          setHeight(response.data);
        } else {
          setPopupData({ open: true, type: 'error', message: 'Failed to fetch height details' });
        }
      } catch (error) {
        setPopupData({ open: true, type: 'error', message: error.message || "An error occurred" });
      }
    }

    const fetchBloodGroup = async () => {
      try {
        const response = await getBloodGroup();
        if (response.status === 200 || response.status === 201) {
          setBloodGroup(response.data);
        } else {
          setPopupData({ open: true, type: 'error', message: 'Failed to fetch blood group details' });
        }
      } catch (error) {
        setPopupData({ open: true, type: 'error', message: error.message || "An error occurred" });
      }
    }

    const fetchMarritalStatus = async () => {
      try {
        const response = await getMaritualStatus();
        if (response.status === 200 || response.status === 201) {
          setMaritalStatus(response.data);
        } else {
          setPopupData({ open: true, type: 'error', message: 'Failed to fetch marital status details' });
        }
      } catch (error) {
        setPopupData({ open: true, type: 'error', message: error.message || "An error occurred" });
      }
    }
    const fetchProfileByList = async () => {
      try {
        const response = await getProfileByList();
        setProfileByList(response.data);
      } catch (error) {
        console.error('Error fetching profile by list:', error);
      }
    };
    fetchMarritalStatus();
    fetchBloodGroup();
    fetchHeight();
    fetchProfileByList();
    const ageArray = Array.from({ length: 83 }, (_, i) => i + 18);
    setAges(ageArray);
  }, []);

  const handleDobChange = (event) => {
    const { value } = event.target; // ensure event.target is accessed properly
    if (!value) return; // add a check to avoid undefined value

    const selectedDate = new Date(value); // converting the input value to a Date object
    const currentDate = new Date();

    let age = currentDate.getFullYear() - selectedDate.getFullYear();
    const monthDiff = currentDate.getMonth() - selectedDate.getMonth();
    const dayDiff = currentDate.getDate() - selectedDate.getDate();

    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--; // if the birthday hasn't occurred yet this year, subtract one from the age
    }
    console.log("value", value);

    formik.setFieldValue('age', age); // set the calculated age in the form
    formik.setFieldValue('date_of_birth', value); // also set the selected date
  };

  // Monitor changes in marital status and "Have Children" selection
  useEffect(() => {
    const maritalChildrenStatusIds = [2, 3, 4, 5]; // IDs representing marital statuses that require children fields

    // Show "Have children?" field based on marital status
    const isMaritalStatusValid = maritalChildrenStatusIds.includes(formik.values.maritalStatus);
    setShowChildrenField(isMaritalStatusValid);

    // Hide children living status by default
    setShowChildrenLivingStatus(false);
  }, [formik.values.maritalStatus]);

  // Show children living status based on "Have children?" selection
  useEffect(() => {
    setShowChildrenLivingStatus(formik.values.no_of_Children !== 0 && formik.values.no_of_Children !== '');
  }, [formik.values.no_of_Children]);

  return (
    <div className="col-lg-9 col-md-10 col-12">
      <Card className="editProfileBlock mt-3">
        <CardHeader
          avatar={
            <ArrowBackIcon sx={{ color: '#FF8008' }} onClick={() => navigate(-1)} />
          }
          title="Basic Details"
          subheader="Update your details to help us suggest more suitable matche"
          titleTypographyProps={{ sx: { color: '#FF8008', fontSize: '20px', fontWeight: '500' } }}
        />
        <CardContent>
          <form onSubmit={formik.handleSubmit}>
            <div className="row">
              <div className="col-md-6">
                <TextField
                  fullWidth
                  label="First Name"
                  variant="outlined"
                  className="mb-3"
                  name="name"
                  disabled
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.name && Boolean(formik.errors.name)}
                  helperText={formik.touched.name && formik.errors.name}
                  InputProps={{
                    style: { textAlign: 'center' }, // For older Material-UI versions, does not work in all cases
                    inputProps: {
                      style: { textAlign: 'center' }, // Center-aligns text in the input field
                    },
                  }}
                />
              </div>
              <div className="col-md-6">
                <TextField
                  fullWidth
                  label="Last Name"
                  variant="outlined"
                  className="mb-3"
                  name="last_name"
                  disabled
                  value={formik.values.last_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.last_name && Boolean(formik.errors.last_name)}
                  helperText={formik.touched.last_name && formik.errors.last_name}
                  InputProps={{
                    style: { textAlign: 'center' }, // For older Material-UI versions, does not work in all cases
                    inputProps: {
                      style: { textAlign: 'center' }, // Center-aligns text in the input field
                    },
                  }}
                />
              </div>
              <div className="col-md-6">
                <TextField
                  fullWidth
                  label="Date of Birth"
                  type="date"
                  variant="outlined"
                  className="mb-3"
                  name="date_of_birth"
                  disabled
                  value={formik.values.date_of_birth}
                  onChange={handleDobChange}
                  InputLabelProps={{ shrink: true }}
                  error={formik.touched.date_of_birth && Boolean(formik.errors.date_of_birth)}
                  helperText={formik.touched.date_of_birth && formik.errors.date_of_birth}
                  InputProps={{
                    style: { textAlign: 'center' }, // For older Material-UI versions, does not work in all cases
                    inputProps: {
                      style: { textAlign: 'center' }, // Center-aligns text in the input field
                    },
                  }}
                />
              </div>
              <div className="col-md-6">
                <TextField
                  fullWidth
                  label="Age"
                  variant="outlined"
                  className="mb-3"
                  name='age'
                  disabled
                  value={formik.values.age}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.age && Boolean(formik.errors.age)}
                  helperText={formik.touched.age && formik.errors.age}
                  InputProps={{
                    style: { textAlign: 'center' }, // For older Material-UI versions, does not work in all cases
                    inputProps: {
                      style: { textAlign: 'center' }, // Center-aligns text in the input field
                    },
                  }}
                >
                </TextField>
              </div>
              <div className="col-md-6">
                <TextField
                  fullWidth
                  disabled
                  select
                  label="Gender"
                  variant="outlined"
                  className="mb-3"
                  name="gender"
                  value={formik.values.gender}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.gender && Boolean(formik.errors.gender)}
                  helperText={formik.touched.gender && formik.errors.gender}
                >
                  <MenuItem value="">Select Gender</MenuItem>
                  <MenuItem value="M">Male</MenuItem>
                  <MenuItem value="F">Female</MenuItem>
                </TextField>
              </div>
              <div className="col-md-6">
                <TextField
                  fullWidth
                  select
                  label="Marital Status"
                  variant="outlined"
                  className="mb-3"
                  name="maritalStatus"
                  value={formik.values.maritalStatus}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.maritalStatus && Boolean(formik.errors.maritalStatus)}
                  helperText={formik.touched.maritalStatus && formik.errors.maritalStatus}
                >
                  <MenuItem value="">Select Marital Status</MenuItem>
                  {maritalstatus.filter((item) => item.id != 7)
                    .map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.status}
                      </MenuItem>
                    ))}
                </TextField>
              </div>

              {/* Conditional rendering for "Have children?" field */}
              {showChildrenField && (
                <div className="col-md-6">
                  <TextField
                    fullWidth
                    select
                    label="Number Of Children"
                    variant="outlined"
                    className="mb-3"
                    name="no_of_Children"
                    value={formik.values.no_of_Children}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.no_of_Children && Boolean(formik.errors.no_of_Children)}
                    helperText={formik.touched.no_of_Children && formik.errors.no_of_Children}
                  >
                    <MenuItem value="">Select an option</MenuItem>
                    <MenuItem value="0">None</MenuItem>
                    <MenuItem value="1">1</MenuItem>
                    <MenuItem value="2">2</MenuItem>
                    <MenuItem value="3">3</MenuItem>
                    <MenuItem value="4">4 and above</MenuItem>

                  </TextField>
                </div>
              )}

              {/* Conditional rendering for "Children Living Status" field */}
              {showChildrenLivingStatus && (
                <div className="col-md-6">
                  <TextField
                    fullWidth
                    select
                    label="Children Living Status"
                    variant="outlined"
                    className="mb-3"
                    name="childrenLivingStatus"
                    value={formik.values.childrenLivingStatus}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.childrenLivingStatus && Boolean(formik.errors.childrenLivingStatus)}
                    helperText={formik.touched.childrenLivingStatus && formik.errors.childrenLivingStatus}
                  >
                    <MenuItem value="">Select an option</MenuItem>
                    <MenuItem value="Living with me">Living with me</MenuItem>
                    <MenuItem value="Not Living with me">Not Living with me</MenuItem>
                  </TextField>
                </div>
              )}
              <div className="col-md-6">
                <TextField
                  fullWidth
                  select
                  label="Height"
                  variant="outlined"
                  className="mb-3"
                  name="height"
                  value={formik.values.height}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.height && Boolean(formik.errors.height)}
                  helperText={formik.touched.height && formik.errors.height}
                >
                  <MenuItem value="">Select Height</MenuItem>
                  {height.map((item) => (
                    <MenuItem key={item.id} value={item.height_id}>
                      {item.height}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
              <div className="col-md-6">
                <TextField
                  fullWidth
                  select
                  label="Blood Group"
                  variant="outlined"
                  className="mb-3"
                  name="bloodGroup"
                  value={formik.values.bloodGroup}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.bloodGroup && Boolean(formik.errors.bloodGroup)}
                  helperText={formik.touched.bloodGroup && formik.errors.bloodGroup}
                >
                  <MenuItem value="">Select Blood Group</MenuItem>
                  {bloodgroup.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.blood_name}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
              <div className="col-md-6">
                <TextField
                  fullWidth
                  select
                  label="Register By"
                  variant="outlined"
                  className="mb-3"
                  name="registerBy"
                  value={formik.values.registerBy}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.registerby && Boolean(formik.errors.registerBy)}
                  helperText={formik.touched.registerby && formik.errors.registerBy}
                >
                  <MenuItem value="">Please Select</MenuItem>
                  {profileByList.map((profile) => (
                    <MenuItem key={profile.id} value={profile.id}>{profile.name}</MenuItem>
                  ))}
                </TextField>
              </div>
              <div className="col-12">
                <TextField
                  fullWidth
                  label="About Me"
                  variant="outlined"
                  className="mb-3"
                  multiline
                  rows={3}
                  name="about_me"
                  value={formik.values.about_me}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.about_me && Boolean(formik.errors.about_me)}
                  helperText={formik.touched.about_me && formik.errors.about_me}
                />
              </div>
            </div>
            {/* <div className="d-grid col-4 mx-auto mt-2"> */}
            <Button type="submit" variant="contained" sx={{ backgroundColor: '#FF8008' }}>
              {formik.isSubmitting ? 'Saving...' : 'Save Changes'}
            </Button>
            {/* </div> */}
          </form>
        </CardContent>
      </Card>

      <Popup
        open={popupData.open}
        type={popupData.type}
        message={popupData.message}
        onClose={handleClosePopup}
      />
    </div >
  );
};
